import React from 'react';
import { useSelector } from 'react-redux';
import { Radio } from 'lucide-react';
import { RootState } from '../../configuration';
import DonateSetting from '../user-setting/tabs/donate-setting';
import { TabDonate } from '../profile/components/DonateTab';

/**
 * Công cụ livestream (trước 17/10 tên "Kênh Donate"; sếp: thực chất trang này dành cho streamer cài đặt buổi live).
 * Creator: cấu hình nhận donate + link nhận/livestream (DonateSetting) + tổng thu nhập & lịch sử (TabDonate).
 * User thường: DonateSetting hiện CTA "Mở nhận donate".
 */
const DonatePage: React.FC = () => {
  const profile = useSelector((state: RootState) => state.features.auth.profile);
  const isCreator = !!profile?.canReceiveDonation;

  return (
    <div className="mx-auto flex w-full max-w-[960px] flex-col gap-6 px-4 py-6 md:px-6">
      <div className="flex items-center gap-3">
        <span className="flex size-11 shrink-0 items-center justify-center rounded-2xl bg-[#EAEFFA] text-[#0057FF] dark:bg-slate-700 dark:text-blue-300">
          <Radio size={22} />
        </span>
        <div>
          <h1 className="text-[22px] font-bold text-[#19052f] dark:text-white md:text-[26px]">Công cụ livestream</h1>
          <p className="text-[14px] text-slate-500 dark:text-slate-400">
            {isCreator
              ? 'Cài đặt cho buổi livestream: thông báo donate, mục tiêu, vòng quay, phát nhạc, hỏi đáp và link dán vào OBS.'
              : 'Dành cho streamer. Mở nhận donate để bắt đầu cài đặt livestream.'}
          </p>
        </div>
      </div>

      {/* Cấu hình + link nhận donate / livestream (hoặc CTA mở donate cho user thường) */}
      <DonateSetting />

      {/* Tổng thu nhập donate + lịch sử — chỉ hiện khi đã là creator */}
      {isCreator && <TabDonate />}
    </div>
  );
};

export default DonatePage;
